import EDC from '../../../shared/globals';

EDC.Animations.FlyToScreen = function (scene, notes) {
  this.scene = scene;
  this.notes = notes;
};

EDC.Animations.FlyToScreen.prototype.start = function () {
  this.notes.map((note) => {
    note.x = 2500;
    return true;
  });
  this.notes.map((note) => {
    this.scene.tweens.add({
      targets: note,
      x: note.init_pos_x,
      y: note.init_pos_y,
      duration: 600,
      delay: 150,
      ease: 'Quint.easeOut',
    });
    return true;
  }, this);
};

export default EDC.Animations.FlyToScreen;
